
import { Vue, Component } from 'vue-property-decorator'

const config = {
  name: 'c-button-label'
}

@Component(config)
export default class CButtonLabel extends Vue {}
